import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import Select from "react-select";

import { IOrder } from "@src/types/api";

import { STRIPE_LINK } from "@lib/globals";
import { capitalize, currencyFormat, defaultDateTimeFormat } from "@lib/utils";

import { OrderDetailsProps } from "@LeagueManagement/Order/types/order";

const OrderDetails = ({
    order,
    setOrderStatus,
    handleOrderUpdate,
    handleReinstateOrderShow,
}: OrderDetailsProps): React.JSX.Element => {
    const orderStatuses: IOrder["status"][] = [
        "pending",
        "processing",
        "completed",
        "cancelled",
    ];

    return (
        <>
            <h3>Order Details</h3>
            <Row className="orderDetails">
                <Col xs={6} sm={3}>
                    <h5>Order Status:</h5>
                </Col>
                <Col xs={6} sm={3}>
                    <Select
                        key={order.status}
                        isSearchable={false}
                        isClearable={false}
                        options={orderStatuses.map(s => ({
                            value: s,
                            label: capitalize(s),
                        }))}
                        defaultValue={{
                            value: capitalize(order.status),
                            label: capitalize(order.status),
                        }}
                        onChange={e => {
                            setOrderStatus(e!.value as IOrder["status"]);
                        }}
                    />
                </Col>
                <Col xs={6} sm={3}>
                    <h5>Order Date:</h5>
                </Col>
                <Col xs={6} sm={3}>
                    {defaultDateTimeFormat.format(new Date(order.date))}
                </Col>
                <Col xs={6} sm={3}>
                    <h5>Name:</h5>
                </Col>
                <Col xs={6} sm={3}>
                    {order.user.name}
                </Col>
                <Col xs={6} sm={3}>
                    <h5>Email:</h5>
                </Col>
                <Col xs={6} sm={3} className="email">
                    {order.user.email}
                </Col>

                {order.status === "completed" && (
                    <>
                        <Col xs={6} sm={3}>
                            <h5>Order Completion Date:</h5>
                        </Col>
                        <Col xs={6} sm={3}>
                            {order.completionDate &&
                                defaultDateTimeFormat.format(
                                    new Date(order.completionDate),
                                )}
                        </Col>
                        <Col xs={6} sm={3}>
                            <h5>Phone:</h5>
                        </Col>
                        <Col xs={6} sm={3}>
                            {order.user.phone}
                        </Col>
                    </>
                )}

                <Col xs={6} sm={3}>
                    <h5>Payment Type:</h5>
                </Col>
                <Col xs={6} sm={3}>
                    {order.paymentType}
                </Col>

                <Col xs={6} sm={3}>
                    <h5>
                        {(Number(order.discount) || 0) +
                            (Number(order.checkDiscount) || 0) >
                        0
                            ? "Subtotal"
                            : "Order Total:"}
                    </h5>
                </Col>
                <Col xs={6} sm={3}>
                    {currencyFormat.format(order.total)}
                </Col>

                {order.coupon && (
                    <>
                        <Col xs={6} sm={3}>
                            <h5>Coupon Used:</h5>
                        </Col>
                        <Col xs={6} sm={3}>
                            {order.coupon.code}
                        </Col>
                    </>
                )}
                {Number(order.discount) > 0 && (
                    <>
                        <Col xs={6} sm={3}>
                            <h5>Coupon Discount:</h5>
                        </Col>
                        <Col xs={6} sm={3}>
                            {currencyFormat.format(order.discount)}
                        </Col>
                    </>
                )}
                {Number(order.checkDiscount) > 0 && (
                    <>
                        <Col xs={6} sm={{ span: 3, offset: 6 }}>
                            <h5>Check Discount:</h5>
                        </Col>
                        <Col xs={6} sm={3}>
                            {currencyFormat.format(order.checkDiscount)}
                        </Col>
                    </>
                )}
                {(Number(order.discount) ||
                    0 + Number(order.checkDiscount) ||
                    0) > 0 && (
                    <>
                        <Col xs={6} sm={{ span: 3, offset: 6 }}>
                            <h5>Order Total:</h5>
                        </Col>
                        <Col xs={6} sm={3}>
                            {currencyFormat.format(
                                order.total -
                                    (Number(order.discount) || 0) -
                                    (Number(order.checkDiscount) || 0),
                            )}
                        </Col>
                    </>
                )}
                {order.paymentType === "Credit Card" && (
                    <>
                        <Col xs={6} sm={3}>
                            <h5>Stripe Link:</h5>
                        </Col>
                        <Col xs={6} sm={9} className="stripeLink">
                            <a
                                href={`${STRIPE_LINK}${order.paymentDetails?.paymentIntentId}`}
                                target="_blank"
                            >{`${STRIPE_LINK}${order.paymentDetails?.paymentIntentId}`}</a>
                        </Col>
                    </>
                )}

                <Col xs={3}>
                    <Button variant="primary" onClick={handleOrderUpdate}>
                        Update Order
                    </Button>
                </Col>
                {order.status === "cancelled" && (
                    <Col xs={3}>
                        <Button
                            variant="success"
                            onClick={handleReinstateOrderShow}
                        >
                            Reinstate Order
                        </Button>
                    </Col>
                )}
            </Row>
        </>
    );
};

export default OrderDetails;
